import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const TYPE_TONES = {
  Usage: 'bg-primary bg-opacity-10 text-primary',
  'Top Up': 'bg-success bg-opacity-10 text-success',
  Payout: 'bg-orange-500 bg-opacity-10 text-orange-500',
  Commission: 'bg-purple bg-opacity-10 text-purple',
  Adjustment: 'bg-body-text bg-opacity-10 text-body-text'
}

const STATUS_DOT = {
  Completed: 'bg-success',
  Pending: 'bg-orange-500',
  Failed: 'bg-danger'
}

const COLUMNS = [
  { key: 'dateTime', label: 'Date & Time' },
  { key: 'account', label: 'Account' },
  { key: 'reference', label: 'Reference ID' },
  { key: 'description', label: 'Description' },
  { key: 'type', label: 'Type' },
  { key: 'amount', label: 'Amount' },
  { key: 'balanceAfter', label: 'Balance After' },
  { key: 'balance', label: 'Balance' }
]

function formatAmount(amount) {
  const isCredit = amount >= 0
  const formatted = `${isCredit ? '+' : '-'}GHS ${Math.abs(amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
  return { formatted, isCredit }
}

export default function TransactionTable({ title, rows, onRowClick }) {
  return (
    <div className="w-full flex flex-col gap-4">
      <p className="text-xl font-semibold text-dark-blue">{title}</p>

      <div className="w-full border border-border-lines rounded-lg overflow-hidden">
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-[900px] text-sm">
            <thead>
              <tr className="bg-background border-b border-border-lines">
                {
                  COLUMNS.map((column) => (
                    <th key={column.key} className="text-left font-semibold text-dark-blue px-3 py-2.5 whitespace-nowrap">
                      {column.label}
                    </th>
                  ))
                }
                <th className="w-[60px]" />
              </tr>
            </thead>

            <tbody>
              {
                rows.length === 0 ? (
                  <tr>
                    <td colSpan={COLUMNS.length + 1}>
                      <div className="flex flex-col items-center gap-2 py-12 text-center">
                        <div className="w-16 h-16 rounded-full bg-primary bg-opacity-10 flex items-center justify-center">
                          <UIcons.UilReceiptAlt size={30} className="text-primary" />
                        </div>
                        <p className="font-semibold text-dark-blue">No transactions yet</p>
                        <p className="text-sm text-secondary">Transactions will appear here when activity is recorded.</p>
                      </div>
                    </td>
                  </tr>
                ) : rows.map((row) => {
                  const { formatted, isCredit } = formatAmount(row.amount)

                  return (
                    <tr
                      key={row.id}
                      onClick={() => onRowClick(row)}
                      className="border-b border-border-lines last:border-0 cursor-pointer hover:bg-background"
                    >
                      <td className="px-3 py-3 text-dark-blue whitespace-nowrap">{row.dateTime}</td>
                      <td className="px-3 py-3 text-dark-blue whitespace-nowrap">{row.account}</td>
                      <td className="px-3 py-3 text-dark-blue whitespace-nowrap">{row.reference}</td>
                      <td className="px-3 py-3 text-dark-blue">{row.description}</td>
                      <td className="px-3 py-3 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${TYPE_TONES[row.type] || TYPE_TONES.Adjustment}`}>
                          {row.type}
                        </span>
                      </td>
                      <td className={`px-3 py-3 font-medium whitespace-nowrap ${isCredit ? 'text-success' : 'text-danger'}`}>{formatted}</td>
                      <td className="px-3 py-3 text-dark-blue whitespace-nowrap">{row.balanceAfter}</td>
                      <td className="px-3 py-3 text-dark-blue whitespace-nowrap">{row.balance}</td>
                      <td className="px-3 py-3">
                        <span className={`inline-block w-2 h-2 rounded-full ${STATUS_DOT[row.status] || 'bg-secondary'}`} title={row.status} />
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
